<template>
  <div class="akl" v-if="ready">
    <div class="bod-view-txt">
      <!-- 이벤트 페이지 시작 -->
      <div class="os_noticeRes">
        
        <WasteGlassBottleHeader/>

        <!--
            prop: abc 선택정보 초기값, 동의항목 초기값
            event: abc 변경, 동의항목 변경, 이벤트 신청
        -->
        <div class="contBoxWrap padTL padBL" style="background-color:#ebebeb;">
          <WasteGlassApply
            :abcLocale="abcLocale"
            :agrees="agrees"
            @clickapply="apply"
            @changeagree="agree"
            @changelocale="locale"/>

          <WasteGlassBottleFooter/>
        </div>
      </div>
    </div>

    <WasteGlassBottlePopupApply />
    <WasteGlassBottlePopupClosing />
    <WasteGlassBottlePopupDup />
    <WasteGlassBottlePopupUnChecked />

  </div>
</template>

<script>
// Component
import WasteGlassApply from './component/apply.vue'
import WasteGlassBottleHeader from './component/header.vue'
import WasteGlassBottleFooter from './component/footer.vue'

import WasteGlassBottlePopupApply from './component/popupApply.vue'
import WasteGlassBottlePopupClosing from './component/popupClosing.vue'
import WasteGlassBottlePopupDup from './component/popupDup.vue'
import WasteGlassBottlePopupUnChecked from './component/popupUnChecked.vue'

// Library
import axios from 'axios'
import querystring from 'querystring'

export default {
  name: 'wasteGlassBottle',
  components: {
    WasteGlassBottleHeader,
    WasteGlassBottleFooter,
    WasteGlassApply,
    WasteGlassBottlePopupApply,
    WasteGlassBottlePopupClosing,
    WasteGlassBottlePopupDup,
    WasteGlassBottlePopupUnChecked
  },
  data () {
    return {
      aboInfo: Object,
      abcLocale: String,
      abcLocalName: String,
      agrees: Boolean,
      applyResult: Number,
      token_body: {
        client_id: process.env.OCC_AUTH_CLIENT_ID,
        client_secret: process.env.OCC_AUTH_CLIENT_SECRET,
        grant_type: process.env.OCC_AUTH_GRANT_TYPE
      },
      au_token: Object,
      ready: false
    }
  },
  methods: {
    init: async function () { // 초기화
      this.aboInfo = {aboNo: '', aboName: '', aboPhone: ''}
      this.abcLocale = ''
      this.abcLocalName = ''
      this.agrees = false
      this.applyResult = -1
      this.au_token = ''

      await this.checkLogin() // 로그인 체크(회원번호,이름)
      if (this.aboInfo.aboNo) await this.getAccessToken() // OCC token 생성
      if (this.au_token) await this.getPhoneNumber() // 회원정보 조회(전화번호)
    },

    // 로그인 체크
    checkLogin: async function () {
      await axios.get(process.env.OCC_ROOT_URL + '/sso/authorizeEvent', {withCredentials: true}
      ).then(response => {
        if (response.data.header.status === 'ERROR') { // login fail
          window.location.href = process.env.AMWAY_ROOT_URL + '/login'
        } else if (response.data.customerUid != null && response.data.customerUid !== 'none') {
          // login success
          this.aboInfo.aboNo = atob(response.data.customerUid)
          this.aboInfo.aboName = response.data.name
        }
      }).catch(ex => {
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
        window.location.href = process.env.AMWAY_ROOT_URL + '/login'
      })
    },

    // 인증 토큰 발급
    getAccessToken: async function () {
      await axios.post(
        process.env.OCC_AUTH_TOKEN_URL, querystring.stringify(this.token_body),
        {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        }).then(response => {
        if (response.status === 200) {
          if (response.data.searchAbo === null) {
            alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
          } else {
            this.au_token = response.data.access_token
          }
        } else {
          console.log('response.status : ', response.status)
          alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
      })
    },

    // ABO 휴대폰번호 획득
    getPhoneNumber: async function () {
      await axios.get(
        process.env.OCC_ROOT_URL + '/apro/customers/Uid/' + this.aboInfo.aboNo,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.au_token
          }
        }).then(response => {
        if (response.status === 200) {
          if (response.data.searchAbo === null) {
            alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
          } else {
            this.aboInfo.aboPhone = response.data.customers[0].mobileArea + response.data.customers[0].mobileNumber
          }
        } else {
          alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
      })
    },
    agree: function () {
      this.agrees = !this.agrees
    },
    locale: function (locale, localeName) {
      this.abcLocale = locale
      this.abcLocalName = localeName
    },
    apply: async function () {
      this.applyResult = -1
      await axios.post(
        process.env.AWS_GATEWAY_URL_V2 + '/waste-glass-bottle',
        {
          abo_no: this.aboInfo.aboNo,
          abo_nm: this.aboInfo.aboName,
          abo_phone: this.aboInfo.aboPhone,
          abc_locale: this.abcLocale,
          abc_locale_nm: this.abcLocalName
        }).then(response => {
        if (response.status === 200) {
          if (response.data.statusMessage === 'ERROR_CLOSING' || response.data.statusMessage === 'ERROR_OVERFLOW') {
            // eslint-disable-next-line no-undef
            layerPopOver(this, '.pop_artnutri_210924_02')
          } else if (response.data.statusMessage === 'ERROR_DUPLICATED') {
            // eslint-disable-next-line no-undef
            layerPopOver(this, '.pop_artnutri_210924_03')
          } else if (response.data.statusMessage === 'SUCCESS') {
            // eslint-disable-next-line no-undef
            layerPopOver(this, '.pop_artnutri_210924_01')
          }
        } else {
          alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
      })
    }
  },
  mounted: function () {
    window.setTimeout(() => {
      this.ready = true
      this.init()
    }, 500)

    
    var swiper = new Swiper('.cardSection01', {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    
  },
  created: function () {
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR:300,400,500,700&subset=korean');

@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/style.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-lib.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/base.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common-v2.css');

@import 'font_kr.css';

body{margin:0 auto}
.bod-view-txt{padding-top:0}
@media screen and (max-width:639px) {
  body{margin:0 auto}
}

.os_noticeRes .cardNews .swiper-pagination-bullet {background-color: #fff;}
.os_noticeRes .cardNews .swiper-pagination-bullet-active {background-color: #C70535;}

.akl .layerWrapper.artnutri .cbox.layerBox {
    border: 0;
}

</style>





// WEBPACK FOOTER //
// src/views/nutrilite/waste-glass-bottle2/wasteGlassBottle.vue